import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Gheader } from './Gheader';
import styles from './Rate.module.css';
import InventoryTable from './InventoryTable';
import apiService from '../api/apiService';
import InventoryModel from './InventoryModel';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Inventory = () => {
  const hotelId = localStorage.getItem('hotel');
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  const addInventory = newInventory => {
    setInventoryData([newInventory, ...inventoryData]);
  };

  /* Fetching Rates from endpoint and updating local state */
  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    try {
      const response = await apiService.get(`/inventory/?hotel=${hotelId}`);
      setInventoryData(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3 className="ps-2 ps-md-0">Inventory</h3>
          <div className={`${styles.buttonContainer} ps-2 ps-md-0`}>
            <button
              className={styles.addRateButton}
              onClick={() => setIsModelOpen(true)}
            >
              Add inventory
            </button>
            {/* <FilterButton /> */}
          </div>

          <InventoryTable
            data={inventoryData}
            setData={setInventoryData}
            hotelId={hotelId}
          />

          {isModelOpen && (
            <InventoryModel
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              onSave={addInventory}
              hotelId={hotelId}
            />
          )}
        </div>
      </div>
      <ToastContainer autoClose={1500} position="top-right" />
    </div>
  );
};

export default Inventory;
